module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify"
  }, [_vm._l((_vm.queue), function(note, index) {
    return [_c('transition', {
      attrs: {
        "name": "notify"
      }
    }, [(note.show) ? _c('div', {
      staticClass: "notification",
      class: 'notification--' + note.type
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (note.icon.length),
        expression: "note.icon.length"
      }]
    }, [_c('icon', {
      attrs: {
        "name": note.icon
      }
    })], 1), _vm._v(" "), (note.headline.length) ? _c('span', [_vm._v(_vm._s(note.headline))]) : _vm._e(), _vm._v(" "), (note.description.length) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(note.description)
      }
    }) : _vm._e()]) : _vm._e()])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9961c232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Notification.vue
// module id = 473
// module chunks = 234